import "./style/_app.scss";
import React, { lazy, Suspense, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./component/Header";
import { Spin } from "antd";

import ReactGA from 'react-ga';
ReactGA.initialize('G-L3N2HDGJQB');

const Landing = lazy(() => import("./pages/Landing"));
const Blog = lazy(() => import("./pages/blog/Blog"));
const BlogDetails = lazy(() => import("./pages/blog/BlogDetails"));
const Videos = lazy(() => import("./pages/videoTuts/Video"));

const App = () => {
  const [theme, setTheme] = useState(false);

  const themeChange = () => {
    setTheme(!theme);
  };
  
  return (
    <Router>
      <Suspense
        fallback={
          <div
            style={{
              // background: "red",
              width: "100%",
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#0d1117",
            }}
          >
            <Spin />
          </div>
        }
      >
        <div
        // className={theme ? "appConatinerDark" : "appConatiner"}
        >
       
      
          <Header theme={theme} themeChange={() => themeChange()} />
          <Routes>
            <Route path="/" element={<Landing theme={theme} />} />
            <Route path="/video" element={<Videos />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:title" element={<BlogDetails />} />
          </Routes>
        </div>
      </Suspense>
    </Router>
  );
};

export default App;
